import { ListboxGroupLabel } from '@reach/listbox';
import { createComponent } from '../../../react/components/core/create-component.js';

/**
 * @deprecated Use new Listbox and its sub-components instead
 */ const LegacyListboxGroupLabel = createComponent({
    displayName: 'LegacyListboxGroupLabel',
    root: ListboxGroupLabel,
    propConfig: {
        classNames: [
            'swan-legacy-listbox-group-label'
        ]
    }
});

export { LegacyListboxGroupLabel };
